import type { ThemeColors, ThemeTypes } from '@/types/themeTypes/ThemeType';
import { getThemeColors } from '@/config/configHelpers';

const colors: ThemeColors = getThemeColors('dark');

const DARK_THEME: ThemeTypes = {
    name: 'DARK_THEME',
    dark: true,
    variables: {
        'border-color': '#333F55',
        'border-opacity': 1
    },
    colors: {
        primary: colors.primary,
        secondary: colors.secondary,
        info: colors.info, // Azul turquesa más estándar para información
        success: colors.success, // Verde estándar para éxito
        warning: colors.warning, // Amarillo estándar para advertencias
        error: colors.error, // Rojo estándar para errores
        errorSecondary: colors.errorSecondary, // Rojo más suave para errores secundarios
        indigo: colors.indigo,
        lightprimary: colors.lightprimary,
        lightinfo: colors.lightinfo,
        lightsecondary: colors.lightsecondary,
        lightsuccess: colors.lightsuccess,
        lighterror: colors.lighterror,
        lightwarning: colors.lightwarning,
        textPrimary: colors.textPrimary,
        textSecondary: colors.textSecondary,
        lightindigo: colors.lightindigo,
        borderColor: colors.borderColor,
        inputBorder: colors.inputBorder,
        containerBg: colors.containerBg,
        background: colors.background,
        hoverColor: colors.hoverColor,
        surface: colors.surface,
        grey100: colors.grey100,
        grey200: colors.grey200,
        darkbg: colors.darkbg,
        bglight: colors.bglight,
        bgdark: colors.bgdark,
        blueBin: colors.blueBin,
        greenProject: colors.greenProject,
        greenNewProject: colors.greenNewProject,
        greenRenovationProject: colors.greenRenovationProject,
        orangeProject: colors.orangeProject,
        yellowProject: colors.yellowProject,
        pinkSecondaryProject: colors.pinkSecondaryProject,
        purpleComercialProject: colors.purpleComercialProject
    }
};

export { DARK_THEME };
